import preval from 'preval.macro'

const getBuildTime = (): string => preval`module.exports = new Date().toLocaleString();`

export const logBuildTime = (): void => {
    const buildTime = `* 🛠 Build Datetime: ${getBuildTime()} *`
    const border = buildTime.replace(/./g, '*')
    console.info([border, buildTime, border].join('\r\n'))
}
